import styled from "@emotion/styled";
import { CssProps } from "../../../../global";
import { ThemeStyle } from "../../../../assets/scss/common/theme";
import { rgba } from "emotion-rgba";


export const CenterBox = styled.div(() => ({
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}));


export const Wrapper = styled(CenterBox) <CssProps>`
  position: fixed;
  overflow: hidden;
  outline: none;
  z-index: ${({ zIndex }: CssProps) => zIndex};
`;


export const BSOverlay = styled(CenterBox) <ThemeStyle & CssProps> `
z-index: ${({ zIndex }: CssProps) => zIndex};
background-color: ${({ theme }: ThemeStyle) => theme.blackOpacity.O7};
`;

export const BsHeader = styled.div(({ zIndex, theme, isScrollDown }: CssProps & ThemeStyle & any) => ({
  backgroundColor: theme.white,
  color: theme.primaryText,
  zIndex: zIndex,
  borderTopRightRadius: "16px",
  borderTopLeftRadius: "16px",
  ...isScrollDown && {
    position: "sticky",
    top: "0px",
  },
  boxShadow: `inset 0px -1px 0px ${rgba(theme.secondaryTextV1, 0.16)}`,
}));

export const BSContent = styled.div(({ zIndex, isScrollDown }: CssProps & ThemeStyle & any) => ({
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: zIndex,
  borderTopRightRadius: "16px",
  borderTopLeftRadius: "16px",
  transition: "all ease-in-out 0.3s",
  maxHeight: isScrollDown ? "70%" : "60%",
  ...isScrollDown && {
    "@media (max-height:680px )": {
      maxHeight: "80%",
    },
    "@media (max-height:580px )": {
      maxHeight: "90%",
    },
  },
  ".bs-body": {
    ...isScrollDown && {
      paddingTop: "96px",
    },
    overflowY: "auto",
  },
}));


export const CloseButton = styled.button`
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  width: 24px;
  height: 24px;
  z-index: 1;
  &:focus , &:active {
    outline: 0;
  }
`;

export const HeaderTop = styled.div`
min-height: 56px;
`;

export const TopTitle = styled.div(({ isScrollDown }: any) => ({
  fontSize: "20px",
  lineHeight: "24px",
  letterSpacing:" 0.15px",
  paddingLeft: "23px",
  opacity: isScrollDown ? "0" : "1",
  transition: "0.6s",
  }));


  export const BottomTitle = styled.div(({ isScrollDown }: any) => ({
  fontSize: "34px",
  lineHeight: "40px",
  letterSpacing:"-0.25px",
  opacity: isScrollDown ? "1" : "0",
  height: isScrollDown ? "auto" : "0",
  transition: "0.6s",
  }));

